
import HomeComponent from "@/views/Covid/Home/HomeComponent";
export default HomeComponent;

